import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import Switch from 'Components/Atoms/Switch/Switch';
import { cn } from 'Utils/cn';
import ErrorMessage from 'Components/Atoms/ErrorMessage/ErrorMessage';

export default function RHFSwitch({ name, children, disabled: isDisabled, className }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, onBlur, ref, disabled }, fieldState: { error } }) => (
                <div className="flex">
                    <label className={cn('inline-flex items-center gap-3', className)}>
                        <Switch
                            checked={value}
                            onCheckedChange={onChange}
                            onBlur={onBlur}
                            ref={ref}
                            disabled={disabled || isDisabled}
                        />
                        {children && <span className="select-none text-sm text-gray-500">{children}</span>}
                    </label>
                    {error && <ErrorMessage message={error.message} className="mt-1" />}
                </div>
            )}
        />
    );
}

RHFSwitch.propTypes = {
    name: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};
